<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-11 17:36:33
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-12 19:30:50
 * @FilePath: \hzs-nutra-wecom-shop\src\views\activity\activityAdd.vue
 * @Description: 门店活动 - 创建活动
-->

<template>
    <div class="page-container">
        <div class="mainContent">
            <van-form ref="formRef" @submit="onSubmit">
                <van-field
                    v-model="formData.title"
                    name="title"
                    placeholder="请输入活动标题"
                    input-align="right"
                    :error="state.errors.title"
                    @update:model-value="onChange('title')"
                >
                    <template #label>
                        <span class="required-mark">*</span>活动标题
                    </template>
                </van-field>

                <van-field
                    v-model="formData.intro"
                    rows="3"
                    autosize
                    type="textarea"
                    input-align="right"
                    right-icon=""
                    placeholder="请输入活动描述"
                    maxlength="50"
                    show-word-limit
                    :error="state.errors.intro"
                    @update:model-value="onChange('intro')"
                >
                    <template #label>
                        <span class="required-mark">*</span>活动描述
                    </template>
                </van-field>

                <van-field
                    v-model="formData.start_time"
                    readonly
                    name="start_time"
                    placeholder="请选择开始时间"
                    input-align="right"
                    @click="
                        showTimePicker = true;
                        activeTimeKey = 'start_time';
                    "
                    :error="state.errors.start_time"
                    @update:model-value="onChange('start_time')"
                >
                    <template #label>
                        <span class="required-mark">*</span>开始时间
                    </template>
                </van-field>
                <van-field
                    v-model="formData.end_time"
                    readonly
                    name="end_time"
                    placeholder="请选择结束时间"
                    input-align="right"
                    @click="
                        showTimePicker = true;
                        activeTimeKey = 'end_time';
                    "
                    :error="state.errors.end_time"
                    @update:model-value="onChange('end_time')"
                >
                    <template #label>
                        <span class="required-mark">*</span>结束时间
                    </template>
                </van-field>

                <!-- 参与奖励 -->
                <van-cell-group title="">
                    <van-cell center :border="false">
                        <template #title>
                            <div class="cell-group-custom-header">
                                <div class="cell-group-custom-title">
                                    参与奖励
                                </div>
                                <div class="cell-group-custom-desc">
                                    点击签到扫客户码后立即发放
                                </div>
                            </div>
                        </template>
                        <template #right-icon>
                            <van-switch v-model="formData.reward" size="20" />
                        </template>
                    </van-cell>

                    <div
                        v-show="formData.reward"
                        class="cell-group-custom-content"
                    >
                        <van-field
                            v-model="formData.points"
                            name="points"
                            placeholder="请输入赠送的积分"
                            input-align="right"
                            :formatter="limitMax100"
                            :error="formData.reward && state.errors.points"
                            @update:model-value="onChange('points')"
                        >
                            <template #label>
                                <span class="required-mark"></span>积分
                            </template>
                        </van-field>

                        <van-field
                            v-model="formData.coupon_name"
                            readonly
                            label="优惠券"
                            name="coupon_uuid"
                            placeholder="请选择赠送的优惠券"
                            input-align="right"
                            :border="false"
                            :error="formData.reward && state.errors.coupon_uuid"
                            @click="handleSelectCoupon"
                        />
                    </div>
                </van-cell-group>

                <!-- 可参与门店 -->
                <van-cell-group title="">
                    <van-field
                        v-model="selectedStoreNames"
                        is-link
                        name="department_uuid"
                        readonly
                        label="可参与门店"
                        placeholder="请选择可参与门店"
                        :error="state.errors.department_uuid"
                        @click="bindDepartmentChange"
                    >
                        <template #label>
                            <span class="required-mark">*</span>可参与门店
                        </template>
                        <template #input>
                            <view class="department_list">
                                <span
                                    class=""
                                    v-for="(
                                        item, index
                                    ) in formData.department_name"
                                    :key="index"
                                    >{{ item.name
                                    }}{{
                                        index !=
                                        formData.department_name.length - 1
                                            ? "、"
                                            : ""
                                    }}</span
                                >
                                <span
                                    :class="[
                                        'field_placeholder',
                                        { error: state.errors.department_uuid },
                                    ]"
                                    v-if="formData.department_name.length == 0"
                                    >请选择可参与门店</span
                                >
                            </view>
                        </template>
                    </van-field>
                    <!-- <van-cell
                        v-if="formData.department_uuid.length > 0"
                        title=""
                        :border="false"
                    >
                        <template #title>
                            <span style="font-size: 12px; color: #969799">
                                已选
                                {{ formData.department_uuid.length }} 家门店
                            </span>
                        </template>
                    </van-cell> -->
                </van-cell-group>

                <!-- 可参加标签 -->
                <van-cell-group title="">
                    <van-cell center :border="false">
                        <template #title>
                            <div class="cell-group-custom-header">
                                <div class="cell-group-custom-title">
                                    可参加标签
                                </div>
                                <div class="cell-group-custom-desc">
                                    点击签到扫客户码后立即发放
                                </div>
                            </div>
                        </template>
                        <template #right-icon>
                            <van-switch v-model="formData.tabs" size="20" />
                        </template>
                    </van-cell>

                    <div
                        v-show="formData.tabs"
                        class="cell-group-custom-content"
                    >
                        <van-cell v-for="(item, index) in state.tagList">
                            <div class="tagsBox">
                                <div
                                    class="tagsTypeTitle flex align-center justify-sb"
                                >
                                    <span>{{ item.name }}</span>

                                    <van-checkbox
                                        :checked="state.selectAllStatus[index]"
                                        @click="
                                            handleSelectAllClick($event, index)
                                        "
                                    >
                                        全选
                                    </van-checkbox>
                                </div>

                                <ul class="tagList flex flex-wrap">
                                    <li
                                        v-for="it in item.childrenTags"
                                        :key="it.uuid"
                                        class="tagItem"
                                        :class="
                                            formData.admin_tag_uuid.findIndex(
                                                (v) => v === it.uuid
                                            ) >= 0
                                                ? 'active'
                                                : ''
                                        "
                                        @click="
                                            handleTagSelected(item, it, index)
                                        "
                                    >
                                        <span>{{ it.name }}</span>
                                    </li>
                                </ul>
                            </div>
                        </van-cell>
                    </div>
                </van-cell-group>
            </van-form>
        </div>

        <div class="bottom_button_box">
            <van-button
                round
                block
                type="primary"
                color="#DCBB89"
                class="save-btn"
                @click="handlePublish"
            >
                发布
            </van-button>
        </div>

        <!-- 选择时间 -->
        <van-popup v-model:show="showTimePicker" position="bottom">
            <van-date-picker
                v-model="currentDate"
                title="选择日期"
                @confirm="onTimeConfirm"
                @cancel="showTimePicker = false"
                :min-date="state.minDate"
                :max-date="state.maxDate"
            />
        </van-popup>

        <!-- 选择门店 -->
        <!-- 选择部门 -->
        <sel-department
            v-model:show="state.showTree"
            :visible="state.showTree"
            :position="state.position"
            :tree-data="state.allLocationData"
            :operableUuids="state.allLowerLevel"
            type="group"
            :isMultiple="true"
            :departmentUuid="formData.department_uuid"
            :selectedItem="state.selectedItem"
            :top="state.top"
            :height="state.height"
            zIndex="999"
            :overlay-top="state.overlayTop"
            @close="closeLocationModal"
            @confirm="onDeptChange"
        />
        <van-popup
            v-model:show="showStorePicker"
            position="bottom"
            round
            :style="{ height: '75%' }"
        >
            <div class="picker-container">
                <!-- 顶部标题栏 -->
                <div class="picker-header">
                    <span class="picker-title">选择门店</span>
                    <span class="picker-count"
                        >已选 {{ selectedStores.length }}</span
                    >
                </div>

                <!-- 搜索框 (如果门店多，建议加上) -->
                <van-search
                    v-model="searchKey"
                    placeholder="搜索门店名称"
                    shape="round"
                    background="#f7f8fa"
                    @input="filterStores"
                />

                <!-- 多选列表区域 -->
                <van-checkbox-group
                    v-model="selectedStores"
                    direction="vertical"
                    class="store-list"
                >
                    <van-cell
                        v-for="store in filteredStores"
                        :key="store.id"
                        :title="store.name"
                        :label="store.address"
                        clickable
                        @click="toggleCheck(store.id)"
                    >
                        <template #right-icon>
                            <van-checkbox
                                :name="store.id"
                                icon-size="18px"
                                @click.stop="toggleCheck(store.id)"
                            />
                        </template>
                    </van-cell>
                </van-checkbox-group>

                <!-- 底部按钮区 -->
                <div class="picker-footer">
                    <van-button
                        block
                        type="primary"
                        size="large"
                        @click="confirmSelection"
                    >
                        确定 ({{ selectedStores.length }})
                    </van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script lang="ts" setup>
// import { Toast } from "vant";
import {
    showToast,
    showLoadingToast,
    closeToast,
    showSuccessToast,
    showFailToast,
    showDialog,
} from "vant";
import dayjs from "dayjs";
import { useCouponStore, useActivityStore, useDepartmentStore } from "@/stores";

import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import {
    getDepartmentListAll,
    getDeptAndPost,
    setDefaultDepartment,
    getFirmRegionDepartment,
    getDepartmentLowerLevel,
} from "@/utils/common";
import SelDepartment from "@/components/selDepartment.vue";

import activityApi from "@/utils/api/activity.js";
import otherApi from "@/utils/api/other.js";

// --------------------------------------- 变量
const localDepartmentdata = ref(
    JSON.parse(localStorage.getItem("departmentdata")) || {}
);
const formRef = ref(null);
const router = useRouter();
const route = useRoute();
const state = reactive({
    tagList: [], // 标签列表 二级数组 一级为标签分组 二级是标签
    selectedTags: [], // 选中的标签组
    selectAllStatus: [], // 与 list 长度相同，存储每组的全选状态
    selectedCouponList: [], // 选中的优惠券列表

    // 表单验证错误信息
    errors: {
        title: false,
        intro: false,
        start_time: false,
        end_time: false,
        points: false,
        coupon_uuid: false,
        department_uuid: false,
        admin_tag_uuid: false,
    },
    minDate: new Date(),
    maxDate: new Date(dayjs().add(60, "day").format("YYYY-MM-DD HH:mm:ss")),

    // 选择组织
    showTree: false, // 选择组织弹窗
    // top: 0,
    height: 400,
    overlayTop: 0,
    position: "bottom",
    allLocationData: [], // 所有部门列表
    departmentInfo: [], // 部门列表
    selDepartmentInfo: {}, // 当前选择部门信息
    selectedLocation: {}, // 当前选择部门名称
    selectedItem: {}, // 当前选择部门信息

    hideInfo: true, // 隐藏信息
    topHeight: 0, // 顶部高度
    filterHeight: 0, // 筛选高度
});
// 表单数据
const formData = reactive({
    title: "",
    intro: "",
    TimeText: "",
    start_time: "",
    end_time: "",
    tabs: false,
    reward: false,
    department_uuid: [],
    department_name: [],
    admin_tag_uuid: [],
    points: null,
    coupon_uuid: [],
    coupon_name: "",
});
// 使用计算属性数组
const isAllSelected = computed({
    get: () => {
        return state.tagList.map((group, idx) => {
            // 根据你的实际逻辑判断当前组是否全选
            const groupItems = group.items || [];
            const selectedCount = groupItems.filter((v) =>
                state.selectedTags.includes(v.uuid)
            ).length;
            return selectedCount === groupItems.length && groupItems.length > 0;
        });
    },
    set: (val) => {},
});
// 监听 selectedTags 变化，同步更新 selectAllStatus
// watch(
//     () => state.selectedTags,
//     () => {
//         state.selectAllStatus = state.tagList.map((group) => {
//             return state.selectedTags.includes(group.uuid);
//         });
//     },
//     { deep: true }
// );
// ************************************ 选择时间
const activeTimeKey = ref("");
// 时间弹窗控制
const showTimePicker = ref(false);
// 日期选择器初始值 (今天)
const currentDate = ref(new Date().toISOString().split("T")[0].split("-"));
// 确认时间
const onTimeConfirm = ({ selectedValues }) => {
    const selectedTime = selectedValues.join("-");
    const { start_time, end_time } = formData;

    // 设置当前值
    formData[activeTimeKey.value] = selectedTime;
    state.errors[activeTimeKey.value] = false;

    // 判断时间逻辑
    if (activeTimeKey.value === "end_time" && start_time) {
        // 选择结束时间，且已有开始时间
        if (selectedTime < start_time) {
            showToast("结束时间不能小于开始时间");
            formData.end_time = ""; // 清空或保留原值
            // 或者：formData.end_time = startTime  // 自动设为开始时间
            showTimePicker.value = false;
            return;
        }
    }

    if (activeTimeKey.value === "start_time" && end_time) {
        // 选择开始时间，且已有结束时间
        if (selectedTime > end_time) {
            showToast("开始时间不能大于结束时间");
            formData.end_time = ""; // 清空结束时间，让用户重新选
            // 或者：formData.end_time = selectedTime  // 自动调整
        }
    }

    showTimePicker.value = false;
};

// ************************************ 选择门店
// const showStorePicker = ref(false);
// const searchKey = ref("");
// const selectedStores = ref([]); // 存储选中的门店 ID 数组
// let allStores = ref([]);
// // --- 计算属性：过滤门店 ---
// const filteredStores = computed(() => {
//     if (!searchKey.value) return allStores.value;
//     return allStores.value.filter(
//         (store) =>
//             store.name.includes(searchKey.value) ||
//             store.address.includes(searchKey.value)
//     );
// });
// // --- 计算属性：格式化显示文本 ---
// const selectedStoreNames = computed({
//     get: () => {
//         if (selectedStores.value.length === 0) return "";
//         const names = allStores.value
//             .filter((s) => selectedStores.value.includes(s.id))
//             .map((s) => s.name);
//         // 如果超过3个，显示 "xx店 等3家"
//         if (names.length > 3) {
//             return `${names[0]} 等${names.length}家`;
//         }
//         return names.join(", ");
//     },
//     set: () => {}, // 只读，不需要 set
// });
// // --- 方法 ---
// // 处理点击单元格 toggle (因为 van-cell clickable 会触发，需要手动控制 checkbox)
// const toggleCheck = (id) => {
//     const index = selectedStores.value.indexOf(id);
//     if (index > -1) {
//         selectedStores.value.splice(index, 1);
//     } else {
//         selectedStores.value.push(id);
//     }
// };
// // 确认选择
// const confirmSelection = () => {
//     if (selectedStores.value.length === 0) {
//         showToast("请至少选择一家门店");
//         return;
//     }
//     showStorePicker.value = false;
//     // 这里可以触发后续逻辑，比如保存表单
// };
// // 搜索过滤 (如果需要防抖，可以加 lodash.debounce)
// const filterStores = () => {
//     // computed 会自动处理，这里留空即可
// };
// 部门相关（保留结构）
const bindDepartmentChange = () => {
    state.selectedItem = {};
    state.showTree = true;
};
const closeLocationModal = () => {
    state.showTree = false;
};
const onDeptChange = (e) => {
    const dept = e;
    formData.department_name = dept.multipleItem || ""; // 部门名称
    formData.department_uuid = dept.departmentUuid || ""; // 部门id
    state.showTree = false;
    if (!formData.department_uuid.length) {
        state.errors.department_uuid = true;
        return;
    }
    if (formData.department_uuid.length) {
        state.errors.department_uuid = false;
        return;
    }
};

// ************************************ 标签
watch(
    () => formData.tabs,
    (newVal, oldVal) => {
        if (newVal) {
            if (state.tagList.length === 0) {
                getTags(); // 获取标签
            }
        }
    }
);
watch(
    () => useCouponStore().getCoupon(),
    (newVal, oldVal) => {
        if (newVal) {
            // 解析传递的数据
            state.selectedCouponList = JSON.parse(newVal);
            formData.coupon_uuid = state.selectedCouponList.map(
                (item) => item.uuid
            );
            formData.coupon_name = state.selectedCouponList
                .map((item) => item.coupon_name)
                .join(",");
            state.errors.coupon_uuid = false;
        }
    }
);
// 积分最大100
const limitMax100 = (value) => {
    // 移除非数字字符
    let num = value.replace(/[^\d]/g, "");
    // 限制最大 100
    if (num > 100) num = 100;
    return num;
};
// 输入框变化时触发
const onChange = (field) => {
    // formData[field] = e.detail.value;
    state.errors[field] = false;
};
/**
 * 判断标签是否选中
 */
const isTagSelected = (uuid) => {
    return formData.admin_tag_uuid.includes(uuid);
};
/**
 * 标签点击选择/取消选择
 * @param {Object} group - 当前分组
 * @param {Object} tag - 当前点击的标签
 */
const handleTagSelected = (group, tag, groupIndex) => {
    const currentUuid = tag.uuid;
    const selectedArray = formData.admin_tag_uuid;

    // 找到当前 uuid 在数组中的索引
    const indexInArray = selectedArray.indexOf(currentUuid);

    let newSelectedArray;

    if (indexInArray > -1) {
        // 取消选择：创建新数组（避免直接修改原数组可能导致的响应式问题）
        newSelectedArray = selectedArray.filter((uuid) => uuid !== currentUuid);
    } else {
        // 添加选择
        newSelectedArray = [...selectedArray, currentUuid];
    }

    // 直接替换整个数组，确保响应式更新
    formData.admin_tag_uuid = newSelectedArray;

    // 更新当前组的全选状态
    updateGroupSelectStatus(group, groupIndex);
};
/**
 * 全选框点击事件（替代 @change，避免 v-model 冲突）
 * @param {Event} event - 点击事件
 * @param {number} groupIndex - 分组索引
 */
const handleSelectAllClick = (event, groupIndex) => {
    // 阻止默认行为，完全手动控制
    event.preventDefault();
    event.stopPropagation();

    const group = state.tagList[groupIndex];
    if (!group?.childrenTags?.length) return;

    const groupUuids = group.childrenTags.map((tag) => tag.uuid);
    const currentSelected = formData.admin_tag_uuid;

    // 判断当前是选中还是取消（根据当前状态取反）
    const willCheck = !state.selectAllStatus[groupIndex];

    let newSelectedArray;

    if (willCheck) {
        // 执行全选：添加该组所有标签
        const otherUuids = currentSelected.filter(
            (uuid) => !groupUuids.includes(uuid)
        );
        newSelectedArray = [...otherUuids, ...groupUuids];
    } else {
        // 执行取消全选：移除该组所有标签
        newSelectedArray = currentSelected.filter(
            (uuid) => !groupUuids.includes(uuid)
        );
    }

    formData.admin_tag_uuid = newSelectedArray;

    // 手动更新全选状态
    state.selectAllStatus[groupIndex] = willCheck;
};

/**
 * 更新指定组的全选状态
 */
const updateGroupSelectStatus = (group, groupIndex) => {
    if (!group?.childrenTags?.length) {
        state.selectAllStatus[groupIndex] = false;
        return;
    }

    const groupUuids = group.childrenTags.map((tag) => tag.uuid);
    const selectedSet = new Set(formData.admin_tag_uuid);

    // 检查该组所有标签是否都被选中
    const isAllSelected = groupUuids.every((uuid) => selectedSet.has(uuid));
    // 使用索引直接赋值，确保响应式更新
    state.selectAllStatus[groupIndex] = isAllSelected;
};

/**
 * 初始化全选状态
 */
const initSelectAllStatus = () => {
    state.selectAllStatus = state.tagList.map((group, index) => {
        if (!group?.childrenTags?.length) return false;

        const groupUuids = group.childrenTags.map((tag) => tag.uuid);
        const selectedSet = new Set(formData.admin_tag_uuid);

        return groupUuids.every((uuid) => selectedSet.has(uuid));
    });
};

// --------------------------------------- 方法、事件
// 登录后初始化（替代原 loginOnce）
const initAfterLogin = async (callback) => {
    // 原逻辑调用了 getFirmRegionDepartment、getDeptAndPost 等
    // let firm_region_uuid = localDepartmentdata.value.department_uuid;
    let firm_region_uuid = 1;
    let signDepartment_uuid =
        (await getFirmRegionDepartment(firm_region_uuid)) || [];
    let departmentInfo = useDepartmentStore().getDepartment("departmentInfo");
    let selDepartmentInfo =
        useDepartmentStore().getDepartment("selDepartmentInfo") || {};
    if (!departmentInfo || departmentInfo.length === 0) {
        departmentInfo = await getDeptAndPost();
    }
    let operableUuids = [];
    departmentInfo.forEach((item) => {
        if (item.department.firm_region_uuid === firm_region_uuid) {
            let index = operableUuids.indexOf(item.department.uuid);
            if (index === -1) {
                operableUuids.push(item.department.uuid);
            }
        }
        // if (item.department.deep <= 3) {
        //     let index = operableUuids.indexOf(signDepartment_uuid);
        //     if (index === -1) {
        //         operableUuids.push(signDepartment_uuid);
        //     }
        // }
    });
    let allLowerLevel = await getDepartmentLowerLevel(operableUuids, "sign");

    state.operableUuids = operableUuids;
    state.departmentInfo = departmentInfo || [];
    state.selDepartmentInfo = selDepartmentInfo || {};
    state.selectedItem = selDepartmentInfo || {};
    state.allLowerLevel = allLowerLevel || [];

    fetchLocationData(); // 获取部门列表
    // 这里省略具体实现
    callback && callback();
};

// 获取部门列表（原 fetchLocationData）
const fetchLocationData = async () => {
    const toast = showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
    state.allLocationData =
        (await getDepartmentListAll(state.operableUuids, "sign")) || [];
    toast.close();
};
onMounted(() => {
    initAfterLogin();
});

// 监听路由变化
watch(
    () => route.path,
    (newPath, oldPath) => {
        // 离开表单页时
        if (oldPath === "/activityAdd" && newPath !== "/activityCoupon") {
            resetForm();
        }

        // 进入表单页时
        if (newPath === "/activity/create") {
            // 检查是否需要清空（从列表页进入时清空）
            if (route.query.reset === "1") {
                resetForm();
            }
        }
    }
);

function handleSelectCoupon() {
    router.push({
        path: "/activityCoupon",
        query: {
            selCoupon: state.selectedCouponList.join(","),
        },
    });
}
// 监听从页面2返回（通过特定标志）
// onBeforeRouteUpdate((to, from) => {
//     if (from.path === "/activityCoupon" && to.query.couponData) {
//         // 解析传递的数据
//         state.selectedCouponList = JSON.parse(to.query.couponData);
//         formData.coupon_uuid = state.selectedCouponList
//             .map((item) => item.uuid)
//             .join(",");
//         // 清理 URL
//         router.replace({ path: to.path, query: {} });
//     }
// });
// 验证函数
const validateForm = () => {
    let isValid = true;

    // 重置错误状态
    Object.keys(state.errors).forEach((key) => (state.errors[key] = false));

    // 验证标题
    if (!formData.title.trim()) {
        state.errors.title = true;
        isValid = false;
    }

    // 验证描述
    if (!formData.intro.trim()) {
        state.errors.intro = true;
        isValid = false;
    }

    // 验证开始时间
    if (!formData.start_time) {
        state.errors.start_time = true;
        isValid = false;
    }

    // 验证结束时间
    if (!formData.end_time) {
        state.errors.end_time = true;
        isValid = false;
    }

    // 验证时间顺序
    if (
        formData.start_time &&
        formData.end_time &&
        formData.end_time < formData.start_time
    ) {
        state.errors.end_time = true;
        showToast("结束时间不能小于开始时间");
        isValid = false;
    }
    // 验证参与奖励
    if (formData.reward) {
        if (!formData.points || formData.points < 0) {
            state.errors.points = true;
            isValid = false;
        }
        if (!formData.coupon_uuid || formData.coupon_uuid.length == 0) {
            state.errors.coupon_uuid = true;
            isValid = false;
        }
    }

    // 验证门店（如果必填）
    if (formData.department_uuid.length === 0) {
        state.errors.department_uuid = true;
        // showToast("请至少选择一家门店");
        isValid = false;
    }

    // 验证标签（如果必填）
    if (formData.tabs && formData.admin_tag_uuid.length === 0) {
        state.errors.admin_tag_uuid = true;
        // showToast("请至少选择一个标签");
        isValid = false;
    }

    return isValid;
};
// 重置表单
const resetForm = () => {
    Object.assign(formData, {
        title: "",
        intro: "",
        TimeText: "",
        start_time: "",
        end_time: "",
        reward: false,
        tabs: false,
        department_uuid: [],
        department_name: [],
        admin_tag_uuid: [],
        points: null,
        coupon_uuid: [],
        coupon_name: "",
    });
    state.errors = {
        title: false,
        intro: false,
        start_time: false,
        end_time: false,
        points: false,
        coupon_uuid: false,
        department_uuid: false,
        admin_tag_uuid: false,
    };
    useCouponStore().setCoupon("");
    initSelectAllStatus();
};
// 点击发布按钮
const handlePublish = async () => {
    if (validateForm()) {
        onSubmit();
    } else {
        showToast("请完善表单信息");
    }
};

const onSubmit = async () => {
    // 提交逻辑...
    let req = {
        ...formData,
    };
    if (formData.start_time && formData.end_time) {
        req.start_time = dayjs(formData.start_time).format(
            "YYYY-MM-DD HH:mm:ss"
        );
        req.end_time = dayjs(formData.end_time).format("YYYY-MM-DD 23:59:59");
    }
    // 奖励
    if (!req.points) {
        delete req.points;
    }
    if (!req.coupon_uuid) {
        delete req.coupon_uuid;
    }
    // 标签 formData.tabs
    if (!req.tabs) {
        delete req.admin_tag_uuid;
    }
    // return req;
    const toast = showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
    let res = await activityApi.createActivity(req);
    toast.close();
    if (res.code === 200) {
        closeToast(toast);
        showSuccessToast({
            message: "发布成功",
            duration: 2000,
        });
        // 关键：清空表单数据
        resetForm();
        let time = setTimeout(() => {
            clearTimeout(time);
            router.back();
        }, 2000);
    } else {
        closeToast(toast);
        showErrorToast({
            message: res.msg || "发布失败",
            duration: 2000,
        });
    }
};
// --------------------------------------- 请求
const getTags = async () => {
    try {
        // 1. 获取标签分类列表
        let categoryList = await getTagsList();

        // 2. 使用 Promise.all 等待所有子标签加载完成
        const tagListWithChildren = await Promise.all(
            categoryList.map(async (item) => {
                let tags = await getChildrenTag(item);
                item.childrenTags = tags;
                return item;
            })
        );

        // 3. 赋值并初始化全选状态
        state.tagList = tagListWithChildren;
        initSelectAllStatus();
    } catch (error) {
        console.error("获取标签失败:", error);
    }
};
// 获取标签分类
const getTagsList = () => {
    return new Promise(async (resolve, reject) => {
        let res = await otherApi.getTagCategoryList();
        if (res.code === 200) {
            resolve(res.data);
        } else {
            reject(res.msg);
        }
    });
};
// 获取标签列表
const getChildrenTag = (data) => {
    return new Promise(async (resolve, reject) => {
        let req = {
            page: 1,
            page_size: 1000,
            category_uuid: data.uuid,
            Status: 1, // 1:显示 2:隐藏
        };
        let res = await otherApi.getTagList(req);
        if (res.code === 200) {
            resolve(res.data);
        } else {
            reject(res.msg);
        }
    });
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/
:root {
    --van-toast-background: rgba(0, 0, 0, 0.7);
    --van-toast-text-color: #fff;
}
.page-container {
    height: 100%;
}
.van-form {
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
}

/* 布局样式优化 */
.cell-group-custom-header {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .cell-group-custom-title {
        line-height: 24px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }

    .cell-group-custom-desc {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin-top: 4px;
        line-height: 18px;

        &.orange {
            color: #ff7123;
        }
    }
}

/* 内容区域的内边距，让展开后看起来不贴边 */
.cell-group-custom-content {
    padding-left: 16px;
    /* 如果需要背景色区分，可以取消下面注释 */
    /* background-color: #f7f8fa; */
}

/* 去掉 van-field 默认的底部边框，保持清爽 */
:deep(.van-field__body) {
    /* 可选：微调对齐 */
}

.field_placeholder {
    color: #999;
}
.field_placeholder.error {
    color: #f00;
}

// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
/* 必填星号样式 */
.required-mark {
    color: #ee0a24;
    margin-right: 4px;
}

/* 标签字体颜色 */
.van-cell__title {
    color: #323233;
    font-size: 15px;
}

/* 输入框占位符颜色 */
.van-field__placeholder {
    color: #c8c9cc;
}

/* 性别选择器特殊调整 */
.gender-group {
    display: flex;
    justify-content: flex-end; /* 靠右对齐，模仿截图 */
    align-items: center;
    padding: 12px 0;
}

.van-radio {
    margin-left: 20px;
}

.van-radio__icon--checked .van-icon {
    background-color: #d48e58; /* 选中态金色 */
    border-color: #d48e58;
}

input,
:deep(input) {
    &:-internal-autofill-selected {
        background-color: transparent !important;
    }
}

// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
.picker-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #f7f8fa;
}

.picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: #fff;
    border-bottom: 1px solid #eee;
}

.picker-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.picker-count {
    font-size: 14px;
    color: #ee0a24; /* Vant 主题红 */
    font-weight: 500;
}

.store-list {
    flex: 1;
    overflow-y: auto;
    background: #fff;
    margin-top: 8px;
}

/* 调整 cell 内部间距，让地址显示更紧凑 */
:deep(.van-cell__label) {
    font-size: 12px;
    color: #969799;
    margin-top: 4px;
}

.picker-footer {
    padding: 10px 16px 20px; /* 底部留白适配 iPhone Home 条 */
    background: #fff;
}

// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
// --------------------------------------------------------
.tagsBox {
    .tagsTypeTitle {
        height: 22px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin-bottom: 10px;
    }
    .tagItem {
        height: 28px;
        line-height: 28px;
        padding: 0 9px;
        background: #f0f0f0;
        border-radius: 4px 4px 4px 4px;

        margin-bottom: 10px;
        margin-right: 10px;

        span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            text-align: center;
            font-style: normal;
            text-transform: none;
        }

        &.active {
            background: #f3ede3;
            span {
                color: #9a753e;
            }
        }
    }
}
</style>
